import React, { useContext, useEffect, useState } from 'react'
import { useTransactions } from '../../hooks/useTransactions';
import { ArrowCircleDownIcon, ArrowCircleUpIcon } from "@heroicons/react/outline";
import { useCurrencyFormat } from '../../hooks/useCurrencyFormat'
import { useFormat } from '../../hooks/useFormat';
import { useNavigate } from "react-router-dom";
import FContainer from "../../components/FContainer/FContainer";
import InfiniteScroll from 'react-infinite-scroll-component';
import { AuthContext } from '../../context/AuthContext';
import { size } from "lodash";



export const MovementScreen = () => {
  const route = useNavigate();

  const { formatWithCurrencyISO } = useCurrencyFormat()
  const { getTransaction } = useTransactions();
  const [currencyId, setCurrencyId] = useState("484")
  const [currentPage, setCurrentPage] = useState(1)
  const [checkUs, setCheckUs] = useState(false)
  const [checkMx, setCheckMx] = useState(false)
  const { formatDateHour } = useFormat();
  const { notificationsSocket, setNotificationsSocket } = useContext(AuthContext);
  const [transactions, setTransactions] = useState([])


  useEffect(() => {
    const _getTransaction = async () => {
      let res = await getTransaction(currencyId, 1);
      if (res[0]) {
        if (transactions.page == undefined) {
          setTransactions(res[1]);
          console.log("size(transactions.page)", res[1].page)
        } else {
          console.log("size(transactions.page)", res[1].page)

          res[1].page = transactions.page.concat(res[1].page)
          setTransactions(res[1])

        }

      } else {
        setTransactions([]);
      }
    };

    if (!!notificationsSocket) {
      if (notificationsSocket.messageType === 'PUSH_RECIEVE_MONEY'){
        if (currentPage == 1){
          transactions.page = undefined
          _getTransaction()
        } else{
          setTransactions([])
          setCurrentPage(1)
        }
      }
    }
  }, [notificationsSocket]);


  useEffect(() => {
    const _getTransaction = async () => {
      let res = await getTransaction(currencyId, currentPage);
      if (res[0]) {
        

        if (transactions.page == undefined) {
          setTransactions(res[1]);
          console.log("size(transactions.page)", res[1].page)
        } else {
          console.log("size(transactions.page)", res[1].page)

          res[1].page = transactions.page.concat(res[1].page)
          setTransactions(res[1])

        }

      } else {
        setTransactions([]);
      }
    };
    _getTransaction();
  }, [currencyId, currentPage])

  useEffect(() => {
    setMexico()
  }, [])

  const setMexico = () => {

    setCurrencyId("484")
    setCheckMx(true);
    setCheckUs(false);
    setCurrentPage(1);
    if (checkMx != true) {
      setTransactions([])
    }
  }

  const setUSA = () => {
    setCurrencyId("840")
    setCheckMx(false);
    setCheckUs(true)
    setCurrentPage(1)
    if (checkUs != true) {
      setTransactions([])
    }
  }


  const fetchMoreData = () => {
    if (currentPage + 1 <= transactions.totalPages) {
      setCurrentPage(currentPage + 1)
    }
  };


  return (
    <>
      <div className='border-0 w-full  grid grid-rows-2'>
        <div className='border-0 row-span-1 font-bold text-Secondary text-center text-[25px]'>Mis movimientos</div>
        <div className='border-0 row-span-1 grid grid-cols-2'>
          <div className='border-0 col-span-1 grid place-items-center relative cursor-pointer' onClick={setMexico}>
            <div className={`bg-Secondary absolute w-5 h-5 rounded-full mb-10 ml-[60px] ${!checkMx ? 'hidden' : ""}`}></div>
            <img className='w-14' src={require("../../components/assets/images/mexico.png")} />
          </div>
          <div className='border-0 col-span-1 grid place-items-center relative cursor-pointer' onClick={setUSA}>
            <div className={`bg-Secondary absolute w-5 h-5 rounded-full mb-10 ml-[60px] ${!checkUs ? 'hidden' : ""}`}></div>
            <img className='w-14' src={require("../../components/assets/images/estados-unidos.png")} />
          </div>
        </div>
      </div>
      <FContainer>
        <div className='w-full p-1'>
          {
            transactions &&

            <InfiniteScroll
              dataLength={size(transactions.page)}
              next={fetchMoreData}
              hasMore={true}
            >
              {transactions.page && (transactions.page).map((transaction, index) => {
                return (
                  <div className='border-2 w-full grid grid-cols-12 rounded-xl shadow-md my-3 p-2 bg-[#f0f0f0] cursor-pointer' onClick={() => {
                    route("/TransactionDetailScreen", {
                      state: {
                        transactionId: transaction.transactionNumber,
                      },
                    });
                  }}>
                    <div className={`border-0 col-span-2 grid place-items-center ${transaction.type == 'PUSH' ? 'text-[#219653]' : 'text-[#EB5757]'}`}>
                      {transaction.type == 'PUSH' ? <ArrowCircleDownIcon className='w-8' /> : <ArrowCircleUpIcon className='w-8' />}
                    </div>
                    <div className='border-0 col-span-10 grid grid-cols-2'>
                      <div className='border-0 col-span-1 pl-2 font-light text-[3vw] sm:text-[14px]'>{formatDateHour(transaction.createDate)}</div>
                      <div className='border-0 col-span-1 pl-2 font-medium text-[4vw] sm:text-[20px]'>{formatWithCurrencyISO(transaction.products[0].amount, "484")}</div>
                      <div className='border-0 col-span-2 font-regular text-[4vw] sm:text-[18px] pl-2'> {transaction.products[0].displayName}</div>
                    </div>
                  </div>

                )
              })}
            </InfiniteScroll>
          }
        </div>

        {/* {
          transactions.map(transaction => (
            <div className='border-0 w-full grid grid-cols-12 rounded-xl shadow-Box my-3 p-2 bg-[#f0f0f0] cursor-pointer' onClick={() => {
              route("/TransactionDetailScreen", {
                state: {
                  transactionId: transaction.transactionNumber,
                },
              });
            }}>
              <div className={`border-0 col-span-2 grid place-items-center ${transaction.type == 'PUSH' ? 'text-[#219653]' : 'text-[#EB5757]'}`}>
                {transaction.type == 'PUSH' ? <ArrowCircleDownIcon className='w-8' /> : <ArrowCircleUpIcon className='w-8' />}
              </div>
              <div className='border-0 col-span-10 grid grid-cols-2'>
                <div className='border-0 col-span-1 pl-2 font-light text-[4vw] sm:text-[18px]'>{formatDate2(transaction.createDate)}</div>
                <div className='border-0 col-span-1 pl-2 font-medium text-[4vw] sm:text-[20px]'>{formatWithCurrencyISO(transaction.products[0].amount, "484")}</div>
                <div className='border-0 col-span-2 font-regular text-[4vw] sm:text-[18px] pl-2'> {transaction.products[0].displayName}</div>
              </div>
            </div>
          ))
        } */}
      </FContainer>
    </>
  )
}
